import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import DrawerSection from '../common/Drawer/DrawerSection'
import DrawerCard from '../common/Drawer/DrawerCard'
import { reinviteCoach } from '../../actions/coachActions'
import CoachCareerStatsModal from './CoachCareerStatsModal'

const CoachDrawerActions = ({ coach }) => {
  const { t } = useTranslation()
  const [isReinviting, setIsReinviting] = useState(false)
  const [isCareerStatsModalOpen, setIsCareerStatsModalOpen] = useState(false)
  const canReinvite = coach.status === 'invited'
  const canViewCareerStats = coach.status === 'active'

  const handleReinviteCoach = () => {
    setIsReinviting(true)
    reinviteCoach(coach.id)
      .then(() => toast.success(t('coaches.actions.reinvitationSent'), { position: toast.POSITION.TOP_RIGHT }))
      .catch((error) => {
        if (error.response?.status === 503) {
          toast.error(t('coaches.actions.reinviteUnavailable'), { position: toast.POSITION.TOP_RIGHT })
        } else {
          const errors = error.response?.data?.errors
          const errorMessage = errors?.[Object.keys(errors)[0]]?.[0] ?? t('coaches.common.somethingWentWrong')
          toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
        }
      })
      .finally(() => setIsReinviting(false))
  }

  if (!canReinvite && !canViewCareerStats) {
    return null
  }

  return (
    <DrawerSection title={t('coaches.drawer.actions')}>
      {canReinvite && (
        <DrawerCard
          icon={<i className='fa fa-envelope-o' aria-hidden='true' />}
          label={t('coaches.actions.reinvite')}
          onClick={handleReinviteCoach}
          disabled={isReinviting}
        />
      )}
      {canViewCareerStats && (
        <DrawerCard
          icon={<i className='fa fa-bar-chart' aria-hidden='true' />}
          label={t('coaches.actions.viewCareerStats')}
          onClick={() => setIsCareerStatsModalOpen(true)}
        />
      )}
      {isCareerStatsModalOpen && (
        <CoachCareerStatsModal
          isOpen={isCareerStatsModalOpen}
          onClose={() => setIsCareerStatsModalOpen(false)}
          coach={coach}
        />
      )}
    </DrawerSection>
  )
}

CoachDrawerActions.propTypes = {
  coach: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
}

export default CoachDrawerActions
